module.exports = __webpack_public_path__ + "static/media/code.380c3bcc.png";